/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrtimesMediaListMediaOutletsDeleteRequest
 */
export interface PrtimesMediaListMediaOutletsDeleteRequest {
    /**
     * 削除するメディアのidリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListMediaOutletsDeleteRequest
     */
    mediaOutletIds: Array<number>;
}

export function PrtimesMediaListMediaOutletsDeleteRequestFromJSON(json: any): PrtimesMediaListMediaOutletsDeleteRequest {
    return PrtimesMediaListMediaOutletsDeleteRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListMediaOutletsDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListMediaOutletsDeleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaOutletIds': json['media_outlet_ids'],
    };
}

export function PrtimesMediaListMediaOutletsDeleteRequestToJSON(value?: PrtimesMediaListMediaOutletsDeleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_outlet_ids': value.mediaOutletIds,
    };
}

